import React from 'react';
import PropTypes from 'prop-types';
import { Button, Flex, Typography } from '@knockrentals/knock-shared-web-v2';
import { TabSection } from '../../TabSections';
import EligibleQualification from './EligibleQualification';
import { getIsAddRowDisabled, getPersonsOptions } from './utils';
import { makeCss } from '../../../../../../../knock-design-system';
import { SECTIONS } from '../../constants';
import {
  FIELD_LABELS,
  INCOME_ELIGIBILITY,
  MAXIMUM_INCOME,
  OCCUPANTS,
} from '../constants';

const { DESCRIPTION, TITLE } = SECTIONS.INCOME_ELIGIBILITY;

export const ADD_ROW_LABEL = 'Add row';

const useCss = makeCss({
  columnHeader: {
    flex: 'none',
    width: '200px',
  },
});

const IncomeEligibility = ({
  addEligibilityRow,
  clearEligibilityRowError,
  deleteEligibilityRow,
  incomeEligibility = [],
  updateEligibilityRow,
  validationErrorMessages = {},
}) => {
  const css = useCss();
  const personOptions = getPersonsOptions(incomeEligibility);
  const isAddRowDisabled = getIsAddRowDisabled(incomeEligibility);
  const rowErrors = validationErrorMessages[INCOME_ELIGIBILITY] ?? [];

  return (
    <TabSection description={DESCRIPTION} isDividerHidden title={TITLE}>
      <Flex flexDirection="column" gap={16}>
        {incomeEligibility.length > 0 && (
          <Flex gap={16}>
            <Typography
              color="text.tertiary"
              css={css.columnHeader}
              variant="overline2"
            >
              {FIELD_LABELS[OCCUPANTS]}
            </Typography>

            <Typography
              color="text.tertiary"
              css={css.columnHeader}
              variant="overline2"
            >
              {FIELD_LABELS[MAXIMUM_INCOME]}
            </Typography>
          </Flex>
        )}

        {incomeEligibility.map((row, index) => {
          const { [OCCUPANTS]: occupants, [MAXIMUM_INCOME]: maximumIncome } =
            row;
          return (
            <EligibleQualification
              clearValidationErrorMessage={clearEligibilityRowError(index)}
              deleteEligibleQualification={() => deleteEligibilityRow(index)}
              errorMessages={rowErrors[index]}
              key={`incomeEligibility-row-${index}`}
              maximumIncome={maximumIncome}
              occupants={occupants}
              personOptions={personOptions}
              updateEligibleQualification={updateEligibilityRow(index)}
            />
          );
        })}

        <Flex>
          <Button
            disabled={isAddRowDisabled}
            onClick={addEligibilityRow}
            startIcon="add-circle-md"
            variant="outlined"
          >
            {ADD_ROW_LABEL}
          </Button>
        </Flex>
      </Flex>
    </TabSection>
  );
};

IncomeEligibility.propTypes = {
  addEligibilityRow: PropTypes.func,
  clearEligibilityRowError: PropTypes.func,
  deleteEligibilityRow: PropTypes.func,
  incomeEligibility: PropTypes.arrayOf(
    PropTypes.shape({
      [MAXIMUM_INCOME]: PropTypes.string,
      [OCCUPANTS]: PropTypes.string,
    }),
  ),
  updateEligibilityRow: PropTypes.func,
  validationErrorMessages: PropTypes.shape({
    [INCOME_ELIGIBILITY]: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default IncomeEligibility;
